module.exports = __webpack_public_path__ + "static/media/iphone_14_gold_pro.d119fa01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_gold_pro.jpg
// module id = 2133
// module chunks = 0